import { BaseEntity } from '../../base-entity';

export interface PermissionGroupEntity extends BaseEntity {
  id: number;
  name: string;
  description: string | null;
}

export interface PermissionGroupUserDetails {
  userId: number;
  firstName: string;
  lastName: string;
  nationalId: string;
  phoneNumber: string | null;
  fileUrl: string | null;
}

export enum PermissionResource {
  PROGRAMS = 'programs',
  STUDENTS = 'students',
  LECTURES = 'lectures',
  PAYMENTS = 'payments',
  JOURNAL_ENTRIES = 'journal_entries',
  PAYROLL = 'payroll',
  MASAV_FILES = 'masav_files',
  DEPOSITS = 'deposits',
  SCHOLARSHIPS = 'scholarships',
  ACCOUNTS = 'accounts',
  CONTACTS = 'contacts',
}

export enum PermissionAction {
  READ = 'read',
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  APPROVE = 'approve',
  EXPORT = 'export',
}

export interface PermissionActionState {
  isPermitted: boolean;
  isAvailable: boolean;
  permissionId: number | null;
}

export interface PermissionResponse {
  resource: PermissionResource;
  permissionActions: PermissionActionState[];
}

export interface PermissionEntity extends BaseEntity {
  id: number;
  resource: PermissionResource;
  actionKey: string;
  description: string | null;
}

export interface PermissionWithAssignment extends PermissionEntity {
  /** True when this permission is linked to the requested permission group */
  isAssigned: boolean;
}
export interface PermissionGroupDetails extends PermissionGroupEntity {
  users: PermissionGroupUserDetails[];
  permission: PermissionWithAssignment[];
}

export interface AddUsersToPermissionGroupRequest {
  userIds: number[];
}

export interface UpdatePermissionGroupPermissionsRequest {
  /** Permission entity ids to assign to the group */
  permissions: number[];
}
